<div class="m-b-10">
    <mat-accordion>
        <mat-expansion-panel hideToggle [expanded]="expanded">

            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span>ALERGIAS DECLARADAS</span>
                    <span class="is-mandatory"></span>
                </mat-panel-title>

                <mat-panel-description>
                    <button class="add-edit-button">
                        @if(includeOrUpdate === 'include'){
                        <img src="assets/icons/add_button.svg" (click)="openPopup()" />
                        }
                        @else if(includeOrUpdate === 'update') {
                        <img src="assets/icons/edit_button.svg" (click)="openPopup()" />
                        }
                    </button>
                </mat-panel-description>

                <button mat-icon-button (click)="expanded = !expanded"></button>
            </mat-expansion-panel-header>

            <div class="selected-allergies-area">

            </div>

        </mat-expansion-panel>
    </mat-accordion>
</div>